export const EMPTY_COMPANY = {
  name: "",
  slug: "",
  plan: "trial",
  status: "trial",
  max_branches: 3,
  max_employees: 25,
  renewal_date: "",
  admin_name: "",
  admin_email: "",
  admin_password: "",
  features: {},
};

export const COMPANY_FORM_FIELDS = [
  ["name", "platform.companyName", "text"],
  ["slug", "platform.slug", "text"],
  ["plan", "platform.plan", "text"],
  ["max_branches", "platform.maxBranches", "number"],
  ["max_employees", "platform.maxEmployees", "number"],
  ["renewal_date", "platform.renewal", "date"],
  ["admin_name", "platform.adminName", "text"],
  ["admin_email", "platform.adminEmail", "email"],
  ["admin_password", "platform.adminPassword", "password"],
];

export const REQUIRED_COMPANY_FIELDS = ["name", "slug", "admin_name", "admin_email", "admin_password"];

export const toCompanyPayload = (form) => ({
  ...form,
  max_branches: Number(form.max_branches),
  max_employees: Number(form.max_employees),
  renewal_date: form.renewal_date || null,
  features: form.features,
});
